mainUrl = "https://rosacea-selbsthilfe.de";

jQuery(document).ready(function ($) {
    if ($('#shop-the-post').length) {
        var slug = document.getElementById("shop-the-post").getAttribute("data-name");
        $.ajax({
            url: mainUrl + "/api/posts/" + slug
        }).then(function (data) {
            if (data.length > 0) {
                $('.blog-detail__text').append("<h2 id=\"-passende-produkte-zu-diesem-blogpost-\">🛒 Passende Produkte zu diesem Blogpost 🛒</h2>")
            }
            for (i = 0; i < data.length; i++) {
                $('#shop-the-post').append("<div data-tags=\"" + data[i].filter + "\" class=\"card__noshadow product\">\n" +
                    " <div class=\"product__body\">" +
                    " <div class=\"product__image\">" +
                    " <a angulartics2On=\"click\" angularticsAction=\"shopThePost\" href=\"/produkt-" + data[i].slug + "\"><picture><source srcSet=\"https://d3rqg9znl368e1.cloudfront.net/images/products/" + data[i].webpImage + "\" type=\"image/webp\"> " +
                    " <source srcSet=\"https://d3rqg9znl368e1.cloudfront.net/images/products/" + data[i].picture + "\" type=\"image/png\"> " +
                    " <img src=\"https://d3rqg9znl368e1.cloudfront.net/images/products/" + data[i].picture + "\"></picture></a><br> " +
                    " </div>" +
                    " <div class=\"card__header \"><a href=\"/produkt-" + data[i].slug + "\">" + data[i].name + "</a></div>" +
                    " <p>" + data[i].summary + "</p> " +
                    " </div>" +
                    " </div>");
            }
        });
    }
})
jQuery(document).ready(function ($) {
    if ($('#products').length) {
        $.ajax({
            url: mainUrl + "/api/products"
        }).then(function (data) {
            for (i = 0; i < data.length; i++) {
                let icons = "";
                if (data[i].tags != null) {
                    if (data[i].tags.includes("bionatur")) {
                        icons += "<span class=\"icon-container icon-container--small icon-container__primary\" title=\"Bio/Naturkosmetik\">\n" +
                            "<svg class=\"icon--small icon--white\">\n" +
                            " <use xlink:href=\"/assets/images/solid.svg#leaf\"></use>\n" +
                            "</svg>\n" +
                            "</span>"
                    }
                    if (data[i].tags.includes("vegan")) {
                        icons += "<span class=\"icon-container icon-container--small icon-container__primary\" title=\"Vegan\">\n" +
                            "<svg class=\"icon--small icon--white\">\n" +
                            " <use xlink:href=\"/assets/images/solid.svg#paw\"></use>\n" +
                            "</svg>\n" +
                            "</span>"
                    }
                    if (data[i].tags.includes("favorit")) {
                        icons += "<span class=\"icon-container icon-container--small icon-container__primary\" title=\"Mein Favorit\">\n" +
                            "<svg class=\"icon--small icon--white\">\n" +
                            " <use xlink:href=\"/assets/images/solid.svg#star\"></use>\n" +
                            "</svg>\n" +
                            "</span>"
                    }

                    if (data[i].tags.includes("level1")) {
                        icons += "<span class=\"icon-container  icon-container--small icon-container__primary icon--level\"  title=\"Für Rosacea Anfänger\"> \n" +
                            "1</span>"
                    }
                    if (data[i].tags.includes("level2")) {
                        icons += "<span class=\"icon-container  icon-container--small icon-container__primary icon--level\"  title=\"Für Rosacea Fortgeschrittene\"> \n" +
                            "2</span>"
                    }
                } else {
                    icons = "<div class=\"icon__blind\"></div>"
                }

                $('#products').append("<div data-tags=\"" + data[i].filter + "\" class=\"card__noshadow product\">\n" +
                    " <div class=\"product__body\">" +
                    " <div class=\"product__image\">" +
                    " <a angulartics2On=\"click\" angularticsAction=\"shopThePost\" href=\"/produkt-" + data[i].slug + "\"><picture><source srcSet=\"https://d3rqg9znl368e1.cloudfront.net/images/products/" + data[i].webpImage + "\" type=\"image/webp\"> " +
                    " <source srcSet=\"https://d3rqg9znl368e1.cloudfront.net/images/products/" + data[i].picture + "\" type=\"image/png\"> " +
                    " <img src=\"https://d3rqg9znl368e1.cloudfront.net/images/products/" + data[i].picture + "\"></picture></a><br> " +
                    " " + icons + "</div>" +
                    " <div class=\"card__header \"><a href=\"/produkt-" + data[i].slug + "\">" + data[i].name + "</a></div>" +
                    " <p>" + data[i].summary + "</p> " +
                    " </div>" +
                    " </div>");
            }
        });
    }
});
